import { render, staticRenderFns } from "./ChildrenDetailsGa.vue?vue&type=template&id=24eeaa58&scoped=true"
import script from "./ChildrenDetailsGa.vue?vue&type=script&lang=ts"
export * from "./ChildrenDetailsGa.vue?vue&type=script&lang=ts"
import style0 from "./ChildrenDetailsGa.vue?vue&type=style&index=0&id=24eeaa58&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24eeaa58",
  null
  
)

export default component.exports